import { ProfileNotCompletedChallanges } from './profile-not-completed-challenge-category'
import { ProfileNotCompletedChallengesSkeleton } from './profile-not-completed-challenges-skeleton'
import React from 'react'
import { PageContainer } from 'src/component/page-container/page-container'
import { NotCompletedChallenge } from 'src/dao/core-dao'
import { useNotYetCompletedChallenges } from 'src/hook/use-challenges'

export const ProfileNotCompletedChallenges = (): React.ReactElement => {
  const { data: notYetCompletedChallenges, isLoading, isError } = useNotYetCompletedChallenges()
  const hasNotYetCompletedChallenges = notYetCompletedChallenges && notYetCompletedChallenges.length > 0
  const isReady = !isLoading && !isError

  if (notYetCompletedChallenges?.length === 0 && !isLoading && !isError) return <></>

  return (
    <PageContainer>
      <div>
        <h2 className="text-primary font-evogria text-2xl md:text-[44px] font-normal uppercase m-0 pt-8 md:pt-20 pb-2 md:pb-3">
          Not yet completed
        </h2>
        {(isLoading || isError) && <ProfileNotCompletedChallengesSkeleton />}
        {hasNotYetCompletedChallenges && isReady && (
          <>
            {notYetCompletedChallenges.map((notCompletedChallenge: NotCompletedChallenge) => (
              <ProfileNotCompletedChallanges
                key={notCompletedChallenge.category.id}
                notCompletedChallenge={notCompletedChallenge}
              />
            ))}
          </>
        )}
      </div>
    </PageContainer>
  )
}
